module.exports = __webpack_public_path__ + "img/billings.67c94806.svg";